"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetPack = void 0;
// --------- Life Cycle --------
const resetPack = (pack) => {
    pack.internalBlockPointer = 0;
    pack.blockPointer = 0;
    pack.HTMLPointer = 0;
    pack.currentHTML = "";
    pack.currentDataRotateIndex = 0;
    pack.isDeleting = false;
};
exports.resetPack = resetPack;
